import { ModalProvider } from "../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  //   TableRow,
} from "../../../Table/TableBasic";
import OpretNyButtonBlock from "../../person/id/OpretNyButtonBlock";
import UpdateIcon from "../../../icons/UpdateIcon";
import PlayIcon from "../../../icons/PlayIcon";

export default function Jobs() {
  return (
    <div className="container">
      <h3 className="d-flex gap-2 align-items-center">
        <span className="c-theme-icon c-theme-icon--defaultSize text-primary bg-primary-light">
          <UpdateIcon width={21} />
        </span>
        <span>Jobs / kørsler</span>
      </h3>
      <div className="table-responsive">
        <ModalProvider>
          <TableRoot>
            <TableHead>
              <>
                <th>Navn</th>
              </>
            </TableHead>
            <TableBody>
              <tr>
                <td className="todo">Fakturer Advokatsamfundet - Årlig</td>
                <td className="edit-column">
                  <button type="button" className="btn btn--action">
                    <PlayIcon />
                    <span>Kør ...</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td className="todo">Fakturer Advokatsamfundet - Månedlig</td>
                <td className="edit-column">
                  <button type="button" className="btn btn--action">
                    <PlayIcon />
                    <span>Kør ...</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td className="todo">Fakturer KAF</td>
                <td className="edit-column">
                  <button type="button" className="btn btn--action">
                    <PlayIcon />
                    <span>Kør ...</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td className="todo">Fakturer Advokaten</td>
                <td className="edit-column">
                  <button type="button" className="btn btn--action">
                    <PlayIcon />
                    <span>Kør ...</span>
                  </button>
                </td>
              </tr>
            </TableBody>
          </TableRoot>
          <OpretNyButtonBlock />
        </ModalProvider>
      </div>
    </div>
  );
}
